// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';

import ProRole from './ProRole';

export default class AccountsList extends ApiObject {

  accounts: Array<ProRole> = [];

  postJsonAssignation(data: Object) {
    this.accounts = [];
    _.each(data.accounts, (roleData) => {
      const proRole:ProRole = new ProRole();
      proRole.fromJson(roleData);
      this.roles.push(proRole);
    });
  }
}
